import type { AnimateOptions } from './types';
import { clamp } from './math';
import { isThemeId } from '../themes/registry';

export function parseScriptOptions(
  script: Pick<HTMLScriptElement, 'src' | 'dataset'>,
): AnimateOptions {
  const url = new URL(script.src);
  const read = (key: string): string | undefined =>
    script.dataset[key] ?? url.searchParams.get(key) ?? undefined;
  const bool = (key: string, fallback: boolean): boolean => {
    const value = read(key);
    return value === undefined ? fallback : !['false', '0', 'off'].includes(value.toLowerCase());
  };
  const size = Number(read('size') ?? 150);
  const theme = read('theme') ?? 'naruto';
  if (!isThemeId(theme)) throw new Error(`Animate: unknown theme "${theme}".`);
  return {
    theme,
    assetBase: new URL(`./themes/${theme}/`, url).href,
    interactWithPage: bool('interactions', true),
    autoplay: bool('autoplay', true),
    speech: bool('speech', true),
    size: Number.isFinite(size) ? clamp(size, 80, 240) : 150,
  };
}
